import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["input", "output", "otherInput", "timezoneField"]
  
  connect() {
    // Auto-detect timezone
    this.detectTimezone()
  }
  
  selectChanged() {
    if (this.inputTarget.value === "other") {
      this.outputTarget.classList.remove("hidden")
    } else {
      this.outputTarget.classList.add("hidden")
    }
  }
  
  detectTimezone() {
    if (this.hasTimezoneFieldTarget) {
      // Get the IANA timezone (e.g., "America/Los_Angeles")
      const ianaTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone
      
      // Convert to Rails format using the mapping provided in the page
      if (window.timezoneMapping && window.timezoneMapping[ianaTimezone]) {
        this.timezoneFieldTarget.value = window.timezoneMapping[ianaTimezone]
      } else {
        // Fallback to a common timezone if mapping not found
        this.timezoneFieldTarget.value = "Pacific Time (US & Canada)"
      }
    }
  }
}